import script from "./RangeSliderSection.vue?vue&type=script&setup=true&lang=js"
export * from "./RangeSliderSection.vue?vue&type=script&setup=true&lang=js"

import "./RangeSliderSection.vue?vue&type=style&index=0&id=3de910cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3de910cc"]])

export default __exports__